import { useQuery } from "@tanstack/react-query";
import { getTransactionById } from "../api";

export const useGetTransactionById = (id: string) => {
  const { data, isLoading } = useQuery({
    queryKey: ["TRANSACTON_ID", id],
    queryFn: () => getTransactionById(id),
    select: ({ data }) => data,
    enabled: !!id,
  });
  return { transaction: data, isLoading };
};
